
const CustomPrivateRoute = () => [
  // <Route key="landing-page" path="/landing-page/:id" element={<Landing key={"landing-page"}/>} />
];
export default CustomPrivateRoute;
